import { useIntl } from 'react-intl';
import { AppLanguageTypes } from '@app/types/localizationTypes';

export const useLanguage = (): AppLanguageTypes => useIntl().locale as AppLanguageTypes;
